import React, { useState, useEffect, useMemo } from 'react'
import Header from './../users/Header'
import NavHeader from './../users/NavHeader'
import { RxRocket } from 'react-icons/rx';
import { FaFlagCheckered, FaTimes } from 'react-icons/fa';
import NavMenu from './NavMenu';
import { UserAuth } from '../../context/AuthContext'
import ReactPaginate from 'react-paginate';
import SearchField from "react-search-field";
import { MdOpenInNew } from 'react-icons/md';
import Footer from './../users/Footer'
import Modal from "./../pasukan/Modal";

const Garapan = () => {
    const { user, lihatAirdrop, lihatGarapan } = UserAuth();
    const uname = user.displayName;

    const [error, setError] = useState('');
    const [loading, setLoading] = useState();
    const [showNotification, setShowNotification] = useState(false);
    const [timeoutId, setTimeoutId] = useState(null);

    useEffect(() => {
        return () => {
            clearTimeout(timeoutId);
        };
    }, [timeoutId]);

    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(7);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const result = await lihatAirdrop(uname);
                setData(result);
            } catch (error) {
                setShowNotification(true);
                setError(error);
            }
            setLoading(false);
        };

        fetchData();
        setTimeoutId(setTimeout(() => setShowNotification(false), 7000));
    }, [lihatAirdrop, uname]);

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    const [limitName, setLimitName] = useState(50);
    const [limitChain, setLimitChain] = useState(50);
    const [limitPasukan, setLimitPasukan] = useState(50);

    useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;
            if (screenWidth < 768) {
                setLimitName(17);
                setLimitChain(5);
                setLimitPasukan(22);
            } else {
                setLimitPasukan(42);
                setLimitName(17);
                setLimitChain(5);
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const filteredData = useMemo(() => {
        return data.filter((item) => {
            const statusString = item.status.toString(); // Convert status to string
            return (
                item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.chain.toLowerCase().includes(searchQuery.toLowerCase()) ||
                statusString.toLowerCase().includes(searchQuery.toLowerCase()) // Use the string version of status
            );
        })
            .sort((a, b) => b.added - a.added);
    }, [data, searchQuery]);

    const startIndex = filteredData.length > 0 ? currentPage * itemsPerPage + 1 : 0;
    const endIndex = Math.min(startIndex + itemsPerPage - 1, filteredData.length);
    const itemsToShow = filteredData.slice(startIndex - 1, endIndex);




    const [showModal, setShowModal] = useState(false);

    const handleModalClose = () => {
        setShowModal(false);
    };

    const [garapanKu, setGarapanKu] = useState('');

    const [nameGarapan, setNameGarapan] = useState('');
    const [chainGarapan, setChainGarapan] = useState('');
    const [linkGarapan, setLinkGarapan] = useState('');
    const [noteGarapan, setNoteGarapan] = useState('');
    const [siPenggarap, setPenggarap] = useState([]);
    const [jumlah, setJumlah] = useState('')
    const [added, setAdded] = useState('')

    useEffect(() => {
        if (garapanKu) {
            const fetchData = async () => {
                setLoading(true);
                try {
                    const result = await lihatGarapan(uname, garapanKu);
                    setNameGarapan(result[0].name);
                    setChainGarapan(result[0].chain);
                    setLinkGarapan(result[0].link);
                    setNoteGarapan(result[0].note);
                    setPenggarap(result[0].penggarap)
                    setJumlah(result[0].totalPenggarap)
                    setAdded(result[0].added)
                } catch (error) {
                    setShowNotification(true);
                    setError(error);
                }
                setLoading(false);
            };

            fetchData();
        }
    }, [uname, garapanKu, lihatGarapan]);

    const [currentPenggarapPage, setCurrentPenggarapPage] = useState(0);
    const penggarapPerPage = 5;
    const penggarapPageCount = Math.ceil(siPenggarap.length / penggarapPerPage);

    const displayedPenggarap = siPenggarap.slice(
        currentPenggarapPage * penggarapPerPage,
        (currentPenggarapPage + 1) * penggarapPerPage
    );


    return (
        <div className="antialiased bg-primary md:block md:bg-indigo-50" style={{ backgroundImage: `url('/images/bg-body.png')` }} relative>
            <NavHeader />
            <div className="max-w-[600px] mx-auto min-h-screen bg-slate-100 shadow-2xl relative">
                <Header />
                {loading && (
                    <div className="absolute top-0 left-0 right-0 bottom-0 bg-black opacity-60 flex items-center justify-center z-50">
                        <img src='/logo192.png' alt="Loading..." className="w-10 h-10" />
                    </div>
                )}
                {showNotification && (
                    <div className="px-4 fixed bottom-[50px] w-full max-w-[600px] transform mb-8 animate-fade-in animate-slide-up z-50">
                        <div className="bg-stone-900 text-white w-full rounded p-4 text-sm font-semibold flex justify-between">
                            {error}
                            <span className="text-primary cursor-pointer" onClick={() => setShowNotification(false)}>Ok</span>
                        </div>
                    </div>
                )}
                <div className='pt-3 pb-[96px]'>
                    <div className='bg-white'>
                        <div className='px-4 pt-4 pb-2 md:p-4 flex justify-between items-center'>
                            <div className='flex items-center'>
                                <span className="mr-2">
                                    <RxRocket className='h-[14px] w-[14px] md:h-[16px] md:w-[16px]' />
                                </span>
                                <h1 className='font-semibold text-base md:text-lg'>Garapan</h1>
                            </div>
                            <div className='text-primary md:font-semibold font-bold text-sm md:text-base'>
                                Pelajari
                            </div>
                        </div>
                        <NavMenu />
                        <div className="bottom-0 bg-slate-100 h-[4px] z-10 -mt-1"></div>
                        <div className=''>
                            <div className='flex justify-between items-center'>
                                <div className='flex items-center p-4'>
                                    <span className='mr-2'>
                                        <FaFlagCheckered size='16' />
                                    </span>
                                    <h1 className='font-semibold text-base'>Garapan</h1>
                                </div>
                            </div>
                            <div className='px-4'>
                                <div className='flex justify-between pb-4 items-center'>
                                    <div className='ml-auto'>
                                        <SearchField
                                            placeholder="Search..."
                                            onChange={(value) => {
                                                setSearchQuery(value);
                                                setCurrentPage(0);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="overflow-x-auto">
                                    <table className='w-full items-center text-left table-auto'>
                                        <thead className='font-medium text-sm text-zinc-600 border-b border-t'>
                                            <tr>
                                                <th className='py-2 px-3 w-1/12 text-left'>No.</th>
                                                <th className='py-2 px-3 w-5/12 md:w-6/12'>Airdrop</th>
                                                <th className='py-2 px-3 w-6/12 md:w-5/12'>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody className='font-normal text-sm text-zinc-600 border-b'>
                                            {itemsToShow.map((item, index) => {
                                                const info = item.status === 0 ?
                                                    <button
                                                        onClick={() => { setShowModal(true); setGarapanKu(item.name) }}
                                                        className="flex justify-center items-center">
                                                        <MdOpenInNew size='18px' className='text-red-600 mr-1' /> belum digarap
                                                    </button>
                                                    : item.status > 0 ?
                                                        <button
                                                            onClick={() => { setShowModal(true); setGarapanKu(item.name) }}
                                                            className="flex justify-center items-center">
                                                            <MdOpenInNew size='18px' className='text-primary mr-1' /> done {item.status} pasukan
                                                        </button>
                                                        : 'unknown data';
                                                return (
                                                    <tr key={item.id} className='hover:bg-gray-200'>
                                                        <td className='py-2 px-3 w-1/12 text-left'>{startIndex + index + 1}</td>
                                                        <td className='py-2 px-3 w-5/12 md:w-6/12'>
                                                            {item.name.length > limitName ? (
                                                                <span title={item.name}>{item.name.slice(0, limitName)}...</span>
                                                            ) : (
                                                                <span>{item.name}</span>
                                                            )}  {item.chain !== "" ? (<><span className='font-bold'>
                                                                ({item.chain.length > limitChain ? (
                                                                    <span title={item.chain}>{item.chain.slice(0, limitChain)}...</span>
                                                                ) : (
                                                                    <span>{item.chain}</span>
                                                                )})
                                                            </span></>) : null}

                                                        </td>
                                                        <td className='py-2 px-3 w-6/12 md:w-5/12'>{info}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <div className='text-sm text-zinc-600 mt-4'>
                                    Showing {startIndex > 0 ? startIndex : 0} to {endIndex} of {filteredData.length} entries
                                </div>
                                <ReactPaginate
                                    previousLabel={
                                        <span className="px-4 py-2">
                                            &lt;
                                        </span>
                                    }
                                    nextLabel={
                                        <span className="px-4 py-2">
                                            &gt;
                                        </span>
                                    }
                                    breakLabel='...'
                                    pageCount={Math.ceil(filteredData.length / itemsPerPage)}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={2}
                                    onPageChange={handlePageChange}
                                    containerClassName={'flex justify-center mt-4 text-sm'}
                                    activeClassName={'bg-primary text-white px-4 py-2 !important'}
                                    pageClassName={'border border-gray-100 px-4 py-2'}
                                    breakClassName={'border border-gray-100 px-4 py-2'}
                                    previousClassName={'border border-gray-100 px-4 py-2'}
                                    nextClassName={'border border-gray-100 px-4 py-2'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={showModal} onClose={handleModalClose}>
                <div className="flex justify-end absolute top-2 right-2">
                    <button onClick={handleModalClose}>
                        <FaTimes className="text-gray-400 hover:text-gray-500" />
                    </button>
                </div>
                <div>
                    <div className='relative overflow-hidden border border-slate-100 px-4 py-2 bg-gradient-to-r from-sky-500 to-blue-600 rounded-lg'>
                        <div className='absolute rounded-full w-3/4 h-40 bg-sky-500/60 -left-80 bottom-0'></div>
                        <div className='absolute rounded-full w-3/4 h-40 bg-blue-600/50 -right-80'></div>
                        <div className="text-center">
                            <div className='pb-1'>
                                <h1 className='text-lg md:text-xl font-semibold text-white'>Project Name</h1>
                            </div>
                            <div className='py-1 flex justify-center items-center'>
                                <h1 className='text-base md:text-lg font-semibold text-white mr-1'>
                                    {nameGarapan.length > limitName ? (
                                        <span title={nameGarapan}>{nameGarapan.slice(0, limitName)}...</span>
                                    ) : (
                                        <span>{nameGarapan}</span>
                                    )}
                                </h1>
                                <h2 className='text-sm md:text-lg font-bold text-white'>
                                    {chainGarapan !== "" ?
                                        chainGarapan.length > limitChain ? (
                                            <span title={chainGarapan}>({chainGarapan.slice(0, limitChain)}...)</span>
                                        ) : (
                                            <span>({chainGarapan})</span>
                                        ) : ''}
                                </h2>

                            </div>
                            <div className='pt-1 flex justify-center'>
                                <h1 className='text-xs md:text-base text-white'>Catatan: {noteGarapan}</h1>
                            </div>
                            <div className='pt-2'>
                                <h1 className='text-white text-xs md:text-sm font-normal'>ditambahkan {added}</h1>
                            </div>
                        </div>
                    </div>
                    {jumlah > 0 ? (
                        <>
                            <div className='pt-4'>
                                {displayedPenggarap.map((penggarapObj, index) => (
                                    <div className='flex justify-between items-center pb-2' key={index}>
                                        {Object.keys(penggarapObj).map((key) => (
                                            <>
                                                <div className='w-1/2 text-sm'>
                                                    {key.length > limitPasukan ? (
                                                        <span title={key}>{key.slice(0, limitPasukan)}...</span>
                                                    ) : (
                                                        <span>{key}</span>
                                                    )}
                                                </div>
                                                <div className='w-1/2 text-sm text-right'>digarap: {penggarapObj[key]}</div>
                                            </>
                                        ))}
                                    </div>
                                ))}
                            </div>
                            <ReactPaginate
                                previousLabel={
                                    <span className="px-4 py-2">
                                        &lt;
                                    </span>
                                }
                                nextLabel={
                                    <span className="px-4 py-2">
                                        &gt;
                                    </span>
                                }
                                breakLabel='...'
                                pageCount={penggarapPageCount}
                                marginPagesDisplayed={1}
                                pageRangeDisplayed={2}
                                onPageChange={({ selected }) => setCurrentPenggarapPage(selected)}
                                containerClassName={'flex justify-center mt-4 text-sm'}
                                activeClassName={'bg-primary text-white px-4 py-2 !important'}
                                pageClassName={'border border-gray-100 px-4 py-2'}
                                breakClassName={'border border-gray-100 px-4 py-2'}
                                previousClassName={'border border-gray-100 px-4 py-2'}
                                nextClassName={'border border-gray-100 px-4 py-2'}
                            />
                        </>
                    ) : (<div className='text-base pt-4'>Kamu belum menggarap airdrop ini</div>)}
                </div>
            </Modal>
            <Footer />
        </div >
    )
}

export default Garapan
